"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CategoriesSideBarNavigation = _interopRequireDefault(require("@insided/destination/modules/Categories/CategoriesSideBarNavigation"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'community-navigation';
exports.cssAnchorName = cssAnchorName;

function getCategoryId() {
  var _getInsidedData$categ, _getInsidedData, _getInsidedData$categ2;

  if (typeof window === 'undefined') return null;
  return (_getInsidedData$categ = (_getInsidedData = (0, _insidedDataStorage.getInsidedData)('content')) === null || _getInsidedData === void 0 ? void 0 : (_getInsidedData$categ2 = _getInsidedData.category) === null || _getInsidedData$categ2 === void 0 ? void 0 : _getInsidedData$categ2.id) !== null && _getInsidedData$categ !== void 0 ? _getInsidedData$categ : null;
} // eslint-disable-next-line import/no-anonymous-default-export


var _default = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(_default, _Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    (0, _classCallCheck2.default)(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      categoryId: null
    });
    return _this;
  }

  (0, _createClass2.default)(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Get categoryId from client-side with getInsidedData
      // This is necessary because the widget is rendered via sidebar caching system
      // which doesn't have access to page-specific context (Entire sidebar is cached TTL 120s)
      var categoryId = getCategoryId();
      this.setState({
        categoryId: categoryId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          categoriesV2 = _this$props.categoriesV2;
      var categoryId = this.state.categoryId;
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('box__content', 'box__pad', 'widget-navigation')
      }, title ? (0, _preact.h)("h3", {
        className: "widget-title"
      }, title) : '', (0, _preact.h)(_CategoriesSideBarNavigation.default, {
        key: categoryId !== null && categoryId !== void 0 ? categoryId : undefined,
        currentCategory: categoryId,
        categories: categoriesV2
      }));
    }
  }]);
  return _default;
}(_preact.Component);

exports.default = _default;